
import { defineComponent } from 'vue'

import SearchBar from './components/SearchBar.vue'

export default defineComponent({
    name: 'App',
    components: {
        SearchBar,
    },
    props: {
        api: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },
})
